import ValidationInterface from "@/plans/common/validation-interface";
import {
  bizPlusCategories,
  meetingCategories, proPlusCategories,
  SDKCategories,
  SDKUCCategories,
} from "@/common/persist-cart/categories";
import { BILLING_CYCLE } from "@/common/constants";
import { PLAN_TYPES } from "@/views/succezz/utils";
import { PBX_SUB_TYPES } from "@/common/service/computers/plans/pbx";
import { isInrCurrency } from "@/utils/currency";

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts(cart) {
    return [
      ...this.current(meetingCategories.filter(c => c !== "biz")).conflict([...meetingCategories, ...proPlusCategories, ...bizPlusCategories, ...SDKCategories, ...SDKUCCategories]),
      ...this.current("biz").conflict([...meetingCategories, ...proPlusCategories, ...SDKCategories, ...SDKUCCategories]),
      //support msq
      ...this.current("biz").conflict(["biz"], { sameCategoryReplacement: !cart.config?.canBuyMsqList?.includes("BIZ") || (isInrCurrency() && !window.campaignFlags?.msqSupportINR) }),
      ...this.current("pro").conflict(["pro"], { sameCategoryReplacement: !cart.config?.canBuyMsqList?.includes("ZOPRO") || (isInrCurrency() && !window.campaignFlags?.msqSupportINR) }),
    ];
  }
}

export class MSQRule extends ValidationInterface {
  async conflicts() {
    return function getConflictingPlans(cart, planToAdd) {
      const deviceTypes = ["zoom_device$desk_phone", "zoom_device$headset"];
      if (!deviceTypes.includes(planToAdd.type) && !["pro", "biz"].includes(planToAdd.category)) {
        return [];
      }

      const currencySupportMSQ = !isInrCurrency() || (isInrCurrency() && !window.campaignFlags?.msqSupportINR)
      const canBuyMsq = cart.config?.canBuyMsqList?.length > 0 && currencySupportMSQ;
      const cartPlans = cart.getAllPlans();
      const hasMSQ = cartPlans.filter((p) => ["pro", "biz"].includes(p.category)).length >= 2;
      const devicePlans = cartPlans.filter((p) => deviceTypes.includes(p.type));
      if (hasMSQ && deviceTypes.includes(planToAdd.type)) {
        throw new Error("MSQ can't exists with ZP devices");
      }

      if (devicePlans.length && canBuyMsq && cartPlans.some((p) => p.category === planToAdd.category && planToAdd.billingCycle !== p.billingCycle)) {
        // return devicePlans;
        throw new Error("MSQ can't exists with ZP devices");
      }
    };
  }
}

export class ProPhoneSoftBundleRule extends ValidationInterface {
  async conflicts() {
    return function getConflictingPlans(cart, planToAdd) {
      const cartPlans = cart.getAllPlans();
      let conflictPlans = [];
      //exclude all other bundle code plans
      if (planToAdd?.extra.bundleCode) {
        conflictPlans = conflictPlans.concat(cartPlans.filter((p) => p.extra.bundleCode && p.extra.bundleCode !== planToAdd?.extra.bundleCode));
      }

      //soft bundle can't support msq
      if (planToAdd.category === "pro") {
        if (planToAdd.extra?.bundleCode) {
          conflictPlans = conflictPlans.concat(cartPlans.filter((p) => p.category === "pro"));
        } else {
          conflictPlans = conflictPlans.concat(cartPlans.filter((p) => p.category === "pro" && p.extra?.bundleCode));
        }
      } else if (planToAdd.type === PLAN_TYPES.ZOOM_PHONE) {
        const sameCycleTypes = [PBX_SUB_TYPES.METERED,
          PBX_SUB_TYPES.UNLIMITED,
          PBX_SUB_TYPES.TOLLFREE,
          PBX_SUB_TYPES.PHONE_NUMBER,
          PBX_SUB_TYPES.FEATURE,
          PBX_SUB_TYPES.UNLIMITED_ADDON];
        if (sameCycleTypes.includes(planToAdd.extra.sub_type)) {
          //if planToAdd is soft bundle ZP, remove other ZP plan
          if (planToAdd.extra?.bundleCode) {
            conflictPlans = conflictPlans.concat(cartPlans.filter((p) => sameCycleTypes.includes(p.extra.sub_type)));
          } else {
            //if planToAdd is normal ZP, remove other bundle plan
            conflictPlans = conflictPlans.concat(cartPlans.filter((p) => sameCycleTypes.includes(p.extra.sub_type) && p.extra?.bundleCode));
          }
        }
      }
      return conflictPlans;
    };
  }
}

export class ProAnnualTermMonthlyRule extends ValidationInterface {
  async conflicts() {
    return function getConflictingPlans(cart, planToAdd) {
      if (planToAdd.category !== "pro") {
        return []
      }
      const cartPlans = cart.getAllPlans();
      if (planToAdd.billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        return cartPlans.filter((p) => p.category === "pro" && p.billingCycle !== planToAdd.billingCycle);
      } else {
        return cartPlans.filter((p) => p.category === "pro" && p.billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY);
      }
    };
  }
}
